import { render, staticRenderFns } from "./topBg.vue?vue&type=template&id=c902ffe2&scoped=true&"
import script from "./topBg.vue?vue&type=script&lang=js&"
export * from "./topBg.vue?vue&type=script&lang=js&"
import style0 from "./topBg.vue?vue&type=style&index=0&id=c902ffe2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c902ffe2",
  null
  
)

export default component.exports